import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import React, { useEffect, useState } from 'react';
import AccountAccess from "../pages/AccountLinking/AccountAccess"
import routes from './routes';
import PrivateRoute from './PrivateRoute';
import NotFoundPage from "../pages/NotFoundPage";
import { useDispatch, useSelector } from 'react-redux'
import StyledSnackBar from './../components/StyledSnackBar';
import MainLayout from "../layouts/MainLayout";
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from "@mui/material";
import appTheme from "../theme/appTheme";
import { loadAuthSession, pickAccessToken } from "../helpers/authStorage.helper";
import { setAuthToken } from "../helpers/request.helper";
import { setTenantId } from "../utils/requestHeaders";
import { authenticationTypes } from "../redux/types";
import { getDefaultLanding } from "../config/navigation";

const RootRouter = () => {

    const dispatch = useDispatch();
    const isAuthenticated = useSelector(state => state?.authentication?.loggedIn);
    const app = useSelector((state) => state?.app);
    const [openSnackbar, setOpenSnackBar] = useState(false);
    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        if (isAuthenticated) return;
        const saved = loadAuthSession();
        if (!saved?.loggedIn) return;

        const token = pickAccessToken(saved.user || {});
        if (token) setAuthToken(token);
        if (saved.activeTenantId || saved.tenantId) {
            setTenantId(saved.activeTenantId || saved.tenantId);
        }

        dispatch({
            type: authenticationTypes.LOGIN_SUCCESS,
            user: saved.user || {},
            userType: saved.userType || null,
            tenantId: saved.tenantId || null,
            activeTenantId: saved.activeTenantId || null,
            activeTenantName: saved.activeTenantName || null,
            roles: saved.roles || [],
            permissions: saved.permissions || [],
        });
    }, [dispatch, isAuthenticated]);

    useEffect(() => {
        if (isAuthenticated && (location.pathname === "/" || location.pathname === "")) {
            navigate(getDefaultLanding().path, { replace: true });
        }
    }, [isAuthenticated, location.pathname, navigate])

    useEffect(() => {
        if (app?.error || app?.message) {
            setOpenSnackBar(true);
        }
        else {
            if (openSnackbar) {
                setOpenSnackBar(false)
            }
        }
    }, [app?.error, app?.message]);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackBar(false);
    };

    return (
        <ThemeProvider theme={appTheme}>
            <CssBaseline />
        <main>
            <Routes>
                <Route path='/idpLogin' element={<AccountAccess showLoginPage={true} showAuthorizationPage={false} />} />
                <Route path='/idpAuthorization' element={<AccountAccess showLoginPage={false} showAuthorizationPage={true} />} />
                {routes?.filter(r => r.isPublicRoute)?.map(({ component: Component, path, exact }) => (
                    <Route
                        path={`/${path}`}
                        key={path}
                        exact={exact}
                        element={<Component />}
                    />
                ))}
                <Route element={<PrivateRoute isAuthenticated={isAuthenticated} />}>
                    {routes?.filter(r => !r.isPublicRoute)?.map(({ component: Component, path, exact, subItems }) => (
                        subItems && subItems.length > 0 ?
                            subItems?.filter(rs => !rs.isPublicRoute)?.map(({ component: Component, path, exact }) => (
                                <Route path={`/${path}`} key={path} exact={exact} element={
                                    <MainLayout>
                                        <Component />
                                    </MainLayout>
                                }>
                                </Route>
                            ))
                            :
                            <Route path={`/${path}`} key={path} exact={exact} element={
                                <MainLayout>
                                    <Component />
                                </MainLayout>
                            }>
                            </Route>
                    ))}
                </Route>
                <Route path="*" exact={true} component={NotFoundPage} />
            </Routes>

            {/*SnackBar Messaging Handler*/}
            {app.messageType === "success" ? (
                <StyledSnackBar
                    open={openSnackbar}
                    autoHideDuration={6000}
                    onClose={handleClose}
                    data={{ "type": app.messageType, "message": app.message }}
                />
            ) : (
                <StyledSnackBar
                    open={openSnackbar}
                    autoHideDuration={6000}
                    onClose={handleClose}
                    data={{ "type": app.messageType, "message": app.message }}
                />
            )}
        </main>
        </ThemeProvider>
    )
}

RootRouter.propTypes = {};

export default RootRouter;